import { Close } from "@mui/icons-material";
import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import { TManageStudiesResponse } from "../models";
import { useManageStudiesStore } from "./useManageStudiesStore";

export default function DeleteStudyModal({ study_id, study_name }: Partial<TManageStudiesResponse>) {
  const { ManageStudies, setOpenModal, deleteStudy } = useManageStudiesStore();
  const { isDeleteLoading, openModal } = ManageStudies;

  const handleClose = () => {
    setOpenModal(false);
  };

  const onConfirm = () => {
    deleteStudy(study_id!);
  };

  return (
    <Modal open={openModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          p: "10px",
          borderRadius: "8px",
          minHeight: "auto",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        <div style={{ position: "absolute", right: "6px", top: "10px" }}>
          <IconButton onClick={handleClose} size="small">
            <Close />
          </IconButton>
        </div>
        <Typography variant="h6" component="h1" sx={{ fontWeight: 600, textAlign: "center" }}>
          Delete Study?
        </Typography>
        <Typography>
          Are you sure you want to delete <span style={{ fontWeight: 600, color: "#13294B" }}>{study_name}</span>?
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, flex: 1, width: "100%" }}>
          <Button variant="text" onClick={handleClose} disabled={isDeleteLoading}>
            Cancel
          </Button>
          <Button variant="text" onClick={onConfirm} disabled={isDeleteLoading} sx={{ color: "#D50000" }}>
            {isDeleteLoading ? "Deleting..." : "Delete"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
